module.exports = __webpack_public_path__ + "img/0Q3A2889_L_Black_MockedUp.335d4170.jpg";